/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("AnthropicProvider", ["AIProviderBase"], function (context, cls) {
  /**
   * Anthropic AI provider
   * @class AnthropicProvider
   * @memberOf classes
   */
  class AnthropicProvider extends cls.AIProviderBase /** @lends classes.AnthropicProvider.prototype */ {
    constructor() {
      super("anthropic", "Anthropic", "remote", { rewrite: true });
    }

    /**
     * @inheritdoc
     */
    _getDirectApiHost() {
      return "https://api.anthropic.com";
    }

    /**
     * Base URL for Anthropic Messages API
     * @returns {string}
     * @private
     */
    _getBaseUrl() {
      return this._buildApiUrl("v1/messages");
    }

    /**
     * Rewrite text using Anthropic Message API
     * @inheritDoc
     */
    async rewrite(text, options = {}) {
      const preparedText = this._prepareRewriteInput(text);
      if (preparedText === null) {
        return null;
      }

      const instructions = this._buildRewritePrompt();
      const input = this._buildRewriteInput(preparedText, options);

      const data = await this._request(this._getBaseUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": this._resolveApiKey(options.apiKey),
          "anthropic-version": "2023-06-01",
          "anthropic-dangerous-direct-browser-access": "true"
        },
        body: {
          model: this._getModel("rewrite"),
          max_tokens: context.ThemeService.getValue("gbc-ai-rewrite-anthropic-max-tokens"),
          system: instructions,
          messages: [{ role: "user", content: input }]
        }
      });

      return this._extractOutputText(data);
    }

    /**
     * Extract output text from Google Responses API payload
     * @param {Object} response
     * @returns {string|null}
     * @private
     */
    _extractOutputText(response) {
      if (!response || !Array.isArray(response.content)) {
        return null;
      }

      return response.content
        .filter((part) => part && part.type === "text" && typeof part.text === "string")
        .map((part) => part.text)
        .join("");
    }
  }

  cls.AIProviderBase.registerProvider(AnthropicProvider);
  cls.AnthropicProvider = AnthropicProvider;
});
